import { render, staticRenderFns } from "./WXLaunchBtn.vue?vue&type=template&id=d00dc85e"
import script from "./WXLaunchBtn.vue?vue&type=script&lang=js"
export * from "./WXLaunchBtn.vue?vue&type=script&lang=js"
import style0 from "./WXLaunchBtn.vue?vue&type=style&index=0&id=d00dc85e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports